import styled from '@emotion/styled/macro';

import { ReactComponent as PaymentFailureIcon } from '../../../../assets/icons/payment-failure-icon.svg';

export const Icon = styled(PaymentFailureIcon)`
  margin-bottom: 1.5rem;
`;
